import { render, staticRenderFns } from "./InventoryLogs.vue?vue&type=template&id=cedc4b40"
import script from "./InventoryLogs.vue?vue&type=script&lang=js"
export * from "./InventoryLogs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports